import { AUTH_SESSION } from 'Reducers/auth/types';
import { CONFIG_UPDATE } from 'Reducers/config/types';
import { SET_ENV } from 'Reducers/env/types';
import { INITIALIZATION_ERROR } from 'Reducers/nav/types';
import { setUrls } from 'Utilities/dataHelpers';
import { getAuthSession } from 'Utilities/session';
import { getSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
const root = (pageCtx) => {
    return new Promise((resolve) => {
        const queryParams = pageCtx.query;
        setupInitialization(queryParams)
            .catch((err) => {
            if (store) {
                store.dispatch({
                    type: INITIALIZATION_ERROR,
                    initErrorStatus: err.status,
                });
            }
        })
            .finally(resolve);
    });
};
const setupInitialization = async (queryParams, forceCountry) => {
    const envSession = getSessionObject('env');
    const configSession = getSessionObject('config');
    const country = forceCountry ?? queryParams?.country;
    if (!queryParams && envSession && configSession) {
        store.dispatch({ type: CONFIG_UPDATE, config: configSession });
        store.dispatch({ type: SET_ENV, env: envSession });
        setUrls(configSession, country);
        return;
    }
    const { app, pId, osType, osVersion, appVersion } = queryParams || {};
    await updateConfig(country, app, pId, appVersion, osType, osVersion);
};
const setupLoginLogic = (resolve, pageCtx) => {
    let url = '/login';
    if (pageCtx.querystring) {
        url = url.concat(`?${pageCtx.querystring}`);
    }
    pageCtx.page.redirect(url);
    resolve();
};
/**
 * TEMPORARY: This function will be removed once the integration with the new APIs is completed.
 * It was created to allow the test team to test the Connected Apps Libre features before the API integration is finished.
 * URL path: /connections?deviceId={deviceId}&appVersion={appVersion}&osType={osType}&osVersion={osVersion}&app={app}&country={country}&token={token}
 *
 * @param token
 * @param queryParams
 * @returns
 */
// const setupLibreLogic = async (token: string, queryParams?: NavigationQueryString) => {
//   const { app, country, pId, osType, osVersion, appVersion } = queryParams || {};
//   await updateConfig(country, app, pId, appVersion, osType, osVersion);
//   const decodedToken = jwtDecode<{ id: string; did: string; exp: number; iat: number }>(token);
//   const resp = await mediator.request<ApiResponse<Patient>>('api:invoke', {
//     method: 'GET',
//     url: urls.libreApiCountryUrl + 'v1/patients/' + decodedToken.id,
//     headers: {
//       'X-User-Agent': generateLibreUserAgentHeader(
//         queryParams?.app,
//         queryParams?.appVersion,
//         queryParams?.osType,
//         queryParams?.osVersion
//       ),
//       Authorization: `Bearer ${token}`,
//     },
//     name: 'getPatient',
//   });
//   const patient = resp.data;
//   if (!patient) {
//     return;
//   }
//   const authSession: AuthSession = {
//     user: {
//       id: decodedToken.id,
//       firstName: patient.firstName,
//       lastName: patient.lastName,
//       email: patient.email,
//       country: patient.country,
//       uiLanguage: patient.language,
//       communicationLanguage: '',
//       accountType: '',
//       uom: '',
//       dateFormat: '',
//       timeFormat: '',
//       emailDay: [],
//     },
//     authTicket: {
//       token,
//       expires: decodedToken.exp,
//       duration: decodedToken.exp,
//     },
//   };
//   store.dispatch({ type: AUTH_SESSION, authSession });
//   persistAuthSession(authSession);
// };
const protectedPageAction = (pageCtx) => {
    return new Promise((resolve) => {
        /**
         * TEMPORARY: This validation will be removed once the integration with the new APIs is completed.
         * It was created to allow the test team to test the Connected Apps Libre features before the API integration is finished.
         * URL path: /connections?deviceId={deviceId}&appVersion={appVersion}&osType={osType}&osVersion={osVersion}&app={app}&country={country}&token={token}
         */
        // if (
        //   pageCtx.pathname === '/connections' &&
        //   pageCtx.query?.app === 'libre1' &&
        //   pageCtx.query?.token
        // ) {
        //   setupLibreLogic(pageCtx.query.token, pageCtx.query)
        //     .catch((err) => {
        //       if (store) {
        //         store.dispatch({
        //           type: INITIALIZATION_ERROR,
        //           initErrorStatus: err.status,
        //         });
        //       }
        //     })
        //     .finally(resolve);
        //   return;
        // }
        const authSession = getAuthSession();
        if (!authSession) {
            setupLoginLogic(resolve, pageCtx);
            return;
        }
        store.dispatch({ type: AUTH_SESSION, authSession });
        const queryParams = pageCtx.query;
        setupInitialization(queryParams, authSession.user.country)
            .catch((err) => {
            if (store) {
                store.dispatch({
                    type: INITIALIZATION_ERROR,
                    initErrorStatus: err.status,
                });
            }
        })
            .finally(resolve);
    });
};
// Create your paths that you want to handle here
// you want to most specific earlier and the least specific later
// Note: if one action throws an error (calls promise reject) then the handlePaths
// will move onto the next matching route
const routeActions = [
    {
        regex: [
            /^\/connections/i,
            /^\/llu-pending-connection/i,
            /^\/llu-connection/i,
            /^\/llu-add-connection/i,
            /^\/lv-practice-connection/i,
            /^\/lv-practice-invitation/i,
            /^\/lv-add-practice/i,
            /^\/partner-connection/i,
        ],
        action: protectedPageAction,
    },
    {
        regex: [/^\.*/],
        action: root,
    },
];
export const handlePaths = (ctx) => {
    const doActions = [];
    for (const check of routeActions) {
        for (const r of check.regex) {
            if (ctx.canonicalPath.match(r)) {
                // Add valid actions to chain later
                doActions.push(check.action);
            }
        }
    }
    // Start with a rejected promise
    let p = Promise.reject();
    // Build a negative promise chain that will try the next action if the previous one failed
    // Once an action succeeds the chain ends and the app starts
    for (let i = 0; i < doActions.length; i++) {
        p = p.catch(() => doActions[i](ctx));
    }
    return p;
};
